var Comp = /** @class */ (function () {
    function Comp() {
    }
    return Comp;
}());
export { Comp };
//# sourceMappingURL=component.js.map